import { render, staticRenderFns } from "./DriversOccupancyRow.vue?vue&type=template&id=22596faf&"
import script from "./DriversOccupancyRow.vue?vue&type=script&lang=js&"
export * from "./DriversOccupancyRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports